import React from 'react';
import { Stepper } from '@mui/material';

import { withStyles } from '@mui/styles';

const CustomStepper = withStyles((_theme) => ({
  root: {
    '& .MuiStepIcon-active': { color: '#f55420' },
    '& .MuiStepIcon-completed': { color: '#f55420' },
    '& .Mui-disabled .MuiStepIcon-root': { color: 'gray' },
    padding: '2rem 1rem 2rem 0',
  },
}))(Stepper);

export { CustomStepper };
